import { MouseEvent, useEffect } from 'react';
import { Pagination as BootstrapPagination } from 'react-bootstrap';
import { Pagination } from '../utils/pagination-hooks';

export const PaginationComponent = ({ recordsCount, pagination }: { recordsCount: number; pagination: Pagination }) => {
    const { pageSize, currentPage, setCurrentPage } = pagination;
    const pagesCount = Math.ceil(recordsCount / pageSize);

    useEffect(() => {
        if (pagesCount === 0 && currentPage !== 1) {
            setCurrentPage(1);
        } else if (pagesCount > 0 && currentPage > pagesCount) {
            setCurrentPage(pagesCount);
        }
    }, [currentPage, pagesCount, setCurrentPage]);

    const changePage = (page: number) => (event: MouseEvent<HTMLElement>) => {
        event.preventDefault();

        if (page !== currentPage) {
            setCurrentPage(page);
        }
    };

    const prev = (event: MouseEvent<HTMLElement>) => {
        event.preventDefault();

        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const next = (event: MouseEvent<HTMLElement>) => {
        event.preventDefault();

        if (currentPage < pagesCount) {
            setCurrentPage(currentPage + 1);
        }
    };

    return (
        <BootstrapPagination className='aroma-pagination pt-2'>
            <BootstrapPagination.First onClick={changePage(1)} />
            <BootstrapPagination.Prev onClick={prev} />

            {Array.from(Array(pagesCount).keys())
                .map((page) => page + 1)
                .map((page, i) => {
                    return (
                        (page === pagesCount || page === 1 || (currentPage + 3 > page && currentPage - 3 < page)) && (
                            <BootstrapPagination.Item
                                key={i}
                                active={page === currentPage}
                                onClick={changePage(page)}
                            >
                                {page}
                            </BootstrapPagination.Item>
                        )
                    );
                })}
            <BootstrapPagination.Next onClick={next} />
            <BootstrapPagination.Last onClick={() => pagesCount > 0 && setCurrentPage(pagesCount)} />
        </BootstrapPagination>
    );
};
